// removed by extract-text-webpack-plugin
module.exports = {"indicator":"O9jn-4oHp9KyK--A4_SsZ"};


//////////////////
// WEBPACK FOOTER
// ./src/charts/Indicator.less
// module id = 989
// module chunks = 0